import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CompaniesService {
	constructor(private http: HttpClient) {}

	getCompanies() {
		return this.http.get(`${environment.apiUrl}/api/admin/companies/list`);
	}

	getPackageById(id) {
		return this.http.get(`${environment.apiUrl}/api/admin/companies/package/${id}`);
	}

	getPackages() {
		return this.http.get(`${environment.apiUrl}/api/admin/companies/packages`);
	}

	getCompany(id) {
		return this.http.get(`${environment.apiUrl}/api/admin/companies/${id}`);
	}

	registerCompany(company) {
		return this.http.post(`${environment.apiUrl}/api/admin/companies/register`, company);
	}

	createPaymentSession(company) {
		return this.http.post(`${environment.apiUrl}/api/admin/companies/createPaymentSession`, company);
	}

	createdCompany(company) {
		return this.http.post(`${environment.apiUrl}/api/admin/companies/add`, company);
	}

	updatedCompany(company) {
		return this.http.put(`${environment.apiUrl}/api/admin/companies/update`, company);
	}

	confirmCompanyInformation(params: HttpParams) {
		return this.http.get(`${environment.apiUrl}/api/admin/companies/confirm`, { params });
	}

	generateCompanyCode(companyName: string) {
		return this.http.get(`/api/admin/companies/code/${companyName}`);
	}

  importContacts(companyId: number, file: File) {
    const formData = new FormData();
    formData.append('files', file, file.name);
    return this.http.post(`${environment.apiUrl}/api/admin/companies/contacts/${companyId}`, formData);
  }
}
